import axios from '../base/axios';
import API_KEY from './key';

const GET_MUSIC = 'flixfrenzy/redux/GET_MUSIC';

// eslint-disable-next-line default-param-last
const musicReducer = (state = [], action) => {
  switch (action.type) {
    case GET_MUSIC:
      return action.payload;
    default:
      return state;
  }
};

export const getMusic = () => (dispatch) => {
  axios.get(`discover/movie?api_key=${API_KEY}&with_genres=10749`).then((res) => {
    dispatch({
      type: GET_MUSIC,
      payload: res.data,
    });
  });
};

export default musicReducer;
